const methy_compare_info = {
    "CA12DAP_vs_CA15DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 12th and 15th day after pollination'
    },
    "CA12DAP_vs_CA9DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 12th and 9th day after pollination'
    },
    "CA12DAP_vs_ZY12DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 12th and 12th day after pollination'
    },
    "CA15DAP_vs_CA9DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 15th and 9th day after pollination'
    },
    "CA15DAP_vs_ZY15DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 15th and 15th day after pollination'
    },
    "CA9DAP_vs_ZY9DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 9th and 9th day after pollination'
    },
    "ZY12DAP_vs_ZY15DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 12th and 15th day after pollination'
    },
    "ZY12DAP_vs_ZY9DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 12th and 9th day after pollination'
    },
    "ZY15DAP_vs_ZY9DAP": {
        'Tissue': 'Leaf',
        'Time': 'the 15th and 9th day after pollination'
    }
}
let SelectOPtions=[]
Object.keys(methy_compare_info).map(key=>{
    SelectOPtions.push({
        value: key,
        label:key
    })
})

export  {methy_compare_info,SelectOPtions}